
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/dashboard",
      function () {
        return require("private-next-pages/docs/transfer/dashboard.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/dashboard"])
      });
    }
  